import SingleModelInterface from '../../types/singleModelInterface'
import CustomerTypes from '../customerTypes/customerTypes'
import {OptionsGroup} from './Option'
import filterByCustomerType from './filterByCustomerType'

export function getCarsInCategoriesOptions(
    models: SingleModelInterface[],
    customerType: CustomerTypes
): OptionsGroup {
    if (typeof models === 'undefined' || !models) {
        return {}
    }

    const carsByCustomerType = filterByCustomerType(customerType, models)

    const options = carsByCustomerType.reduce((a, b) => {
        a[b.category.name] = a[b.category.name] || []
        a[b.category.name].push(b.name)

        return a
    }, Object.create(null))

    return options
}
